import { useAuth } from '@core/auth/useAuth'

/** Ecrãs de quando o servidor responde mas não deixa entrar.
 *
 *  `forbidden`: o servidor recusou (workspace arquivado). Antes, a app
 *  entrava em modo local sem dizer nada e a pessoa ficava sem perceber
 *  porque é que os módulos tinham desaparecido.
 *  `server-error`: o servidor falhou (5xx). Deixa tentar outra vez ou
 *  seguir com o viewer local, que nunca depende do servidor.
 */
export default function AcessoBloqueado() {
  const { mode, aviso, logout, refresh, continuarLocal } = useAuth()
  const recusado = mode === 'forbidden'

  return (
    <div className="flex h-full flex-col items-center justify-center bg-[var(--color-bg)] p-6 text-[var(--color-text)]">
      <div
        role="alert"
        className="w-full max-w-md rounded-lg border border-[var(--color-border)] bg-[var(--color-panel)] p-6 shadow-lg"
      >
        <h1 className="text-sm font-semibold">
          {recusado ? 'Acesso terminado' : 'Servidor indisponível'}
        </h1>
        {recusado ? (
          <>
            <p className="mt-3 text-xs text-[var(--color-text-muted)]">
              O servidor recusou o acesso a este workspace
              {aviso ? `: ${aviso}` : '.'}
            </p>
            <p className="mt-2 text-xs text-[var(--color-text-muted)]">
              O acesso foi encerrado pela VN2R. Para o retomar, contacte a
              equipa VN2R.
            </p>
          </>
        ) : (
          <p className="mt-3 text-xs text-[var(--color-text-muted)]">
            Não foi possível validar a sessão: o servidor respondeu com um
            erro. Tente novamente dentro de alguns instantes. Os modelos
            podem ser abertos em modo local, sem os módulos do workspace.
          </p>
        )}
        <div className="mt-5 flex flex-wrap gap-2">
          {recusado ? (
            <button
              type="button"
              onClick={() => void logout()}
              className="rounded bg-[var(--color-accent)] px-3 py-1.5 text-xs font-medium text-[var(--color-bg)] hover:opacity-90"
            >
              Terminar sessão
            </button>
          ) : (
            <>
              <button
                type="button"
                onClick={() => void refresh()}
                className="rounded bg-[var(--color-accent)] px-3 py-1.5 text-xs font-medium text-[var(--color-bg)] hover:opacity-90"
              >
                Tentar novamente
              </button>
              <button
                type="button"
                onClick={continuarLocal}
                className="rounded border border-[var(--color-border)] px-3 py-1.5 text-xs text-[var(--color-text-muted)] hover:text-[var(--color-text)]"
              >
                Continuar em modo local
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
